import { type OnboardingChatResults } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

interface ConvMmMastraThread {
    id: string;
    mastraThreadId: string;
    membershipId: string | null;
    userId: string | null;
    visitorId: string | null;
    agentId: string;
    version: string;
    results: OnboardingChatResults | null;
    createdAt: string;
    updatedAt: string;
}

export const useGetConvMmThread = requestBuilder.query<ConvMmMastraThread>({
    endpoint: '/api/mastra-threads?agentId=conversational-mm-agent',
    queryKey: 'getConvMmThread',
});
